import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import CannedHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/canned-response'),
      meta: {
        featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        return { name: 'canned_list', params: to.params };
      },
    },
    {
      path: frontendURL('accounts/:accountId/settings/canned-response/list'),
      name: 'canned_list',
      meta: {
        featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      component: CannedHome,
    },
  ],
};
